export function defineLocaleService(config) {
    return {
        id: "locale-service",
        create: () => ({
            "1.0.0": () => ({ featureService: config })
        })
    };
}
